import type { SupplierResource } from "../supplier";

export type B2bGateOrderResource = {
  gid: string;
  id: string;
  order_date: string;
  order_number: string;
  is_blocked: boolean;
  created_at: string;
  updated_at: string;
  total_price: string;
  descendants_count: number;
  b2b_gate_supplier_orders?: B2bGateSupplierOrderResource[];
  total_gross_price: string;
  order_summary: Record<
    string,
    {
      gross_price: number;
      net_price: number;
      tax_sum: number;
      vat_percent: number;
    }
  >;
};

export type B2bGateSupplierOrderResource = {
  id: string;
  gid: string;
  b2b_gate_order_id: string;
  b2b_gate_order?: B2bGateOrderResource;
  supplier_id: string;
  supplier?: SupplierResource;
  total_price: string;
  total_gross_price: string;
  currency: string;
  status: B2bGateSupplierOrderStatusEnum;
  shipping_service_provider: string | null;
  tracking_number: string | null;
  b2b_gate_supplier_order_positions?: B2bGateSupplierOrderPositionResource[];
};

export type B2bGateSupplierOrderPositionResource = {
  id: string;
  gid: string;
  b2b_gate_supplier_order_id: string;
  b2b_gate_supplier_order?: B2bGateSupplierOrderResource;
  variant_id: string;
  variant_ean: string;
  variant_sku: string;
  variant_title: string;
  option_value: string;
  quantity_order: string;
  quantity_processed: string;
  small_image: string;
  big_image: string;
  unit_price: string;
  old_unit_price: string;
  vat_percent: string;
  total_price: string;
  amount_of_unit_per_package: string;
};

export interface StockOverflowError {
  id: "stock_overflow";
  label: string;
  amount_in_stock: string;
  ordered_amount: string;
}
export interface StockEmptyError {
  id: "stock_empty";
  label: string;
  amount_in_stock: string;
  ordered_amount: string;
}
export interface PriceMismatchError {
  id: "price_mismatch";
  label: string;
  new_price: string;
  old_price: string;
}
export interface AmountPerPackageMismatchError {
  id: "amount_per_package_mismatch";
  label: string;
  new_amount_per_package: string;
  old_amount_per_package: string;
}

export type PositionError =
  | AmountPerPackageMismatchError
  | PriceMismatchError
  | StockEmptyError
  | StockOverflowError;

export type SupplierErrors = {
  min_purchase_price?: number;
};

export type UpdateB2bGateSupplierOrderPosition = {
  quantity_ordered: string;
  unit_price: string;
};

export type StoreB2bGateSupplierOrderPosition = {
  b2b_gate_order_id: string;
  variant_id: string;
  quantity_ordered: string | number;
  unit_price: string | number;
};

export enum B2bGateSupplierOrderStatusEnum {
  New = "new",
  Ordered = "ordered",
  //  IntegrationError = "integration_error",
  Cancelled = "cancelled",
  Processed = "processed",
  Sent = "sent",
  Delivered = "delivered",
}
